import { Mappable } from '../../_shared/mappable.class';
import { CivicAddress } from '../CivicAddress';

export class Location extends Mappable<Location>  {
    locationId: number;
    name: string;
    timeZone: string;
    timeZoneId: string;
    address: CivicAddress;
    active: boolean;
    dateCreated: Date;
}
